import { render, staticRenderFns } from "./SetCredentials.vue?vue&type=template&id=9c074d30&"
import script from "./SetCredentials.vue?vue&type=script&lang=ts&"
export * from "./SetCredentials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports